import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import ModuleHeader from "../components/ModuleHeader";
import MaterialArrivalLeft from "@/assets/img/cpm/material-arrival-left.png";
import MaterialArrivalRight from "@/assets/img/cpm/material-arrival-right.png";
// 默认模拟数据
const defaultMaterialData = {
    iqcQualifiedRate: 100,
    materialPrepareCycle: 30,
};
const MaterialArrival = ({ className = "", data, }) => {
    const [materialData, setMaterialData] = useState(data || defaultMaterialData);
    useEffect(() => {
        if (data)
            return;
        const fetchMaterialData = async () => {
            const mockResponse = await new Promise((resolve) => {
                setTimeout(() => resolve(defaultMaterialData), 500);
            });
            setMaterialData(mockResponse);
        };
        fetchMaterialData();
    }, [data]);
    return (_jsxs("div", { className: `relative bg-gradient-to-t from-[rgba(7,31,75,0.5)] to-[rgba(6,32,66,0.2)]  flex flex-col ${className} min-h-0`, children: [_jsx(ModuleHeader, { title: "\u6765\u6599\u8D28\u91CF" }), _jsxs("div", { className: "flex-1 w-full flex items-center justify-between min-h-0 ", children: [_jsxs("div", { className: "relative", children: [_jsx("img", { style: {
                                    width: "2.90rem",
                                    height: "0.70rem",
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                }, src: MaterialArrivalLeft, alt: "\u5DE6\u4FA7\u7BAD\u5934\u80CC\u666F\u56FE" }), _jsxs("div", { className: "absolute inset-0 flex flex-col items-center justify-center", children: [_jsx("span", { className: "text-[0.30rem] font-bold text-white", children: `${materialData.iqcQualifiedRate}%` }), _jsx("span", { className: "text-cyan-300 text-[0.16rem]", children: "IQC" })] })] }), _jsxs("div", { className: "relative pl-[0.2rem]", children: [_jsx("img", { style: {
                                    width: "1.29rem",
                                    height: "1.29rem",
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                }, src: MaterialArrivalRight, alt: "\u53F3\u4FA7\u5706\u5F62\u80CC\u666F\u56FE" }), _jsxs("div", { className: "absolute inset-0 flex flex-col items-center justify-center pl-[0.20rem]", children: [_jsx("span", { className: "text-[0.14rem] text-white", children: "\u5907\u6599\u5468\u671F" }), _jsx("span", { className: "text-[0.38rem] font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent", children: materialData.materialPrepareCycle }), _jsx("span", { className: "text-[0.14rem] text-white", children: "(\u5929)" })] })] })] })] }));
};
export default MaterialArrival;
